<template>
    <div
        class="flex items-stretch gap-3.5 rounded-xl border border-rose-200 bg-white p-4 dark:border-rose-500/30 dark:bg-gray-800"
    >
        <div class="w-1 shrink-0 rounded-full bg-rose-600"></div>
        <div class="flex min-w-0 flex-1 flex-col gap-2">
            <div class="flex flex-wrap items-center gap-2.5">
                <span
                    class="rounded-md bg-rose-500/10 px-2 py-0.5 font-mono text-[10px] uppercase tracking-widest text-rose-600 dark:bg-rose-500/15 dark:text-rose-400"
                >
                    Caso aberto
                </span>
                <span
                    class="font-mono text-[11px] text-gray-400 dark:text-gray-500"
                >
                    {{ meta }}
                </span>
            </div>
            <p
                class="max-w-[62ch] text-lg font-semibold leading-snug tracking-tight text-gray-900 dark:text-white"
            >
                <highlighted-text :text="headline" />
            </p>
            <p class="max-w-[76ch] text-sm text-gray-500 dark:text-gray-400">
                Decida na barra abaixo — ou pergunte ao agente ao lado; ele abre
                a seção certa e destaca a evidência.
            </p>
        </div>
    </div>
</template>

<script>
import HighlightedText from "../../../views/monitoring/HighlightedText.vue";

export default {
    name: "RiskCaseBanner",
    components: { HighlightedText },
    props: {
        // Frase com o fato crítico do caso (vem do insight do runoff ou da
        // recomendação do checkpoint).
        headline: { type: String, required: true },
        // Linha mono com origem e prazo ("Parcela grande · decidir até 17/09")
        meta: { type: String, default: "" },
    },
};
</script>
